var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"btn",attrs:{"to":_vm.to}},[_c('span',[_vm._t("default")],2),(_vm.icon)?_c('div',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }